/*
 * @Author: huzhibo
 * @Email: hzbfun@gmail.com
 * @Date: 2019/5/6 9:16
 */
export default {
  computed: {
    operationSuper() {
      let { meta } = this.$route;
      let operationSuper = {};
      if (meta) {
        let { operationIds } = meta;
        if (operationIds) {
          operationIds = operationIds.split(",");
          operationIds.forEach((v) => {
            switch (v) {
              case "1": // 查询
                operationSuper.查询 = true;
                break;
              case "2": // 新增 & 编辑
                operationSuper.编辑 = true;
                break;
              case "3": // 删除
                operationSuper.删除 = true;
                break;
              case "4": // 详情
                operationSuper.详情 = true;
                break;
              case "5": // 导入
                operationSuper.导出 = true;
                break;
              case "6": // 导出
                operationSuper.导入 = true;
                break;
              case "7": // 审核
                operationSuper.审核 = true;
                break;
              case "9": // 权限分配
                operationSuper.权限分配 = true;
                break;
            }
          });
        }
      }
      return operationSuper;
    },
  },
};
